import { Box, Typography } from '@mui/material'
import { toFarsiDigits } from 'farsi-digits'
import _ from 'lodash'
import React, { FC } from 'react'

import IranFlagIcon from '../assests/icons/IranFlagIcon'
interface Props {
  first: string
  second: string
  third: string
  forth: string
}

const NumberPlate: FC<Props> = ({ first, second, third, forth }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'background.paper',
        borderRadius: 0.5,
        minWidth: '150px',
        overflow: 'hidden',
        boxShadow: '0 0 2px rgba(0,0,0,0.5)',
      }}
    >
      <Box sx={{ backgroundColor: 'info.main', height: '100%', px: 0.5 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <img alt='flag' height={16} src='/images/flag.png' width={16} />
          <Typography color='white' display='block' variant='caption'>
            IR
          </Typography>
          <Typography color='white' display='block' variant='caption'>
            IRAN
          </Typography>
        </Box>
      </Box>
      <Box sx={{ flex: 1, display: 'flex', justifyContent: 'space-around' }}>
        <Typography display='block' variant='subtitle1'>
          {toFarsiDigits(_.toNumber(first))}
        </Typography>
        <Typography display='block' variant='subtitle1'>
          {second}
        </Typography>
        <Typography display='block' variant='subtitle1'>
          {toFarsiDigits(_.toNumber(third))}
        </Typography>
      </Box>
      <Box
        sx={{
          borderLeft: '1px solid grey',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          minWidth: '24px',
        }}
      >
        <Typography display='block' variant='caption'>
          ایران
        </Typography>
        <Typography display='block' sx={{ fontSize: 10 }} variant='caption'>
          {toFarsiDigits(_.toNumber(forth))}
        </Typography>
      </Box>
    </Box>
  )
}

export default NumberPlate
